<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Atendimento </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol sm="4">
                  <validation-provider
                    name="telefone"
                    rules="required|max:50"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="Telefone"
                      v-mask="'(##) # ####-####'"
                      :invalid-feedback="errors[0]"
                      placeholder="(XX) X XXXX-XXXX"
                      v-model="form.telefone"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="e-mail"
                    rules="required|max:50"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="E-mail"
                      valid-feedback
                      v-model="form.email"
                      :invalid-feedback="errors[0]"
                      placeholder="example@example.com"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <CInput
                    label="Plataforma de Atendimento"
                    placeholder="Chatbot"
                    disabled
                    v-model="form.plataforma"/>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Login"
                    placeholder="Login da Plataforma"
                    v-model="form.login"/>
                </CCol>
                <CCol sm="6">
                  <CInput
                    label="Senha"
                    placeholder="Senha da Plataforma"
                    v-model="form.senha"/>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="teste()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'attendanceForm',
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.atendimento
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.atendimento 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'atendimento')
        }
      }
    },
    methods: {
      ...mapActions(['saveAtendimento', 'updateAttendance']),
      save() {
        this.saveAtendimento(this.form);
      },
      update() {
        this.updateAttendance(this.form)
      },
      teste() {
        console.log(this.form)
      }
    }
  }
</script>
